import indexCss from "index.module.css";
import { cn } from "lib/utils";
import styles from "./page.module.css";

export default function Home() {
  const pages = [
    { name: "Mortgage Planning", path: "/mortgage", isNew: true },
    { name: "Wealth Accumulation", path: "/wealth" },
    { name: "Retirement Planning", path: "/retirement" },
    { name: "Family Protection", path: "/family" },
    { name: "Education Planning", path: "/education" },
  ];

  return (
    <main className={cn(indexCss.body, styles.main)}>
      <div className={styles.container}>
        <h1 className={styles.header}>Singtel Insurance</h1>

        {/* Desktop Table View */}
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.thPage}>Page</th>
                <th className={styles.thButton}>For Client Testing</th>
                <th className={styles.thButton}>For Dev Testing Only</th>
              </tr>
            </thead>
            <tbody>
              {pages.map((page) => (
                <tr key={page.path}>
                  <td className={styles.tdPage}>
                    {page.name}
                    {page.isNew && <span className={styles.newBadge}>NEW</span>}
                  </td>
                  <td className={styles.tdButton}>
                    <a
                      href={`/iframe-test-css?url=${page.path}`}
                      className={cn(styles.button, styles.buttonGreen)}
                    >
                      Iframe
                    </a>
                  </td>
                  <td className={styles.tdButton}>
                    <a
                      href={page.path}
                      className={cn(styles.button, styles.buttonGray)}
                    >
                      Standalone
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Card View */}
        <div className={styles.mobileContainer}>
          {pages.map((page) => (
            <div key={page.path} className={styles.card}>
              <div className={styles.cardTitle}>
                {page.name}
                {page.isNew && <span className={styles.newBadge}>NEW</span>}
              </div>
              <div className={styles.cardButtons}>
                <a
                  href={`/iframe-test-css?url=${page.path}`}
                  className={cn(styles.button, styles.buttonGreen)}
                >
                  Iframe
                </a>
                <a
                  href={page.path}
                  className={cn(styles.button, styles.buttonGray)}
                >
                  Standalone
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
